import type { MouseEvent } from "react";
import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import { RoomIcon } from "../../icons/RoomIcon";
import { Column } from "../../misc/Column";
import { Row } from "../../misc/Row";
import type { Room } from "../../providers/roomsProvider";

export function RoomMobileListItem(props: {
  room: Room;
  branchName?: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}) {
  const { room, branchName, onClick } = props;
  const theme = useTheme();
  const seatsLabel = room.numberOfSeats === 1 ? "1 Sitzplatz" : `${room.numberOfSeats} Sitzplätze`;
  const details = [seatsLabel, branchName].filter(Boolean).join(" · ");

  return (
    <ButtonBase
      component="div"
      disabled={!onClick}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      sx={{
        alignItems: "stretch",
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxSizing: "border-box",
        display: "block",
        px: 0,
        py: 1,
        textAlign: "left",
        width: "100%",
        "&.Mui-disabled": {
          color: "inherit",
        },
      }}
    >
      <Row sx={{ alignItems: "flex-start", gap: 1.25, minWidth: 0 }}>
        <Box
          sx={{
            alignItems: "center",
            backgroundColor: theme.palette.action.hover,
            borderRadius: "50%",
            color: theme.palette.text.secondary,
            display: "flex",
            flexShrink: 0,
            height: 40,
            justifyContent: "center",
            width: 40,
          }}
        >
          <RoomIcon data-testid="RoomIcon" fontSize="small" />
        </Box>
        <Column sx={{ gap: 0.25, minWidth: 0 }}>
          <Typography variant="body1" sx={{ fontWeight: 600, overflowWrap: "anywhere" }}>
            {room.name}
          </Typography>
          {room.description && (
            <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
              {room.description}
            </Typography>
          )}
          <Typography variant="caption" color="text.secondary" sx={{ overflowWrap: "anywhere" }}>
            {details}
          </Typography>
        </Column>
      </Row>
    </ButtonBase>
  );
}
